var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "the-navbar__user-meta flex items-center" },
    [
      _vm.view === "compartido" ? _c("div", [_vm._v(" Invitado ")]) : _vm._e(),
      _vm.view !== "compartido"
        ? _c(
            "div",
            { staticClass: "text-right leading-tight sm:block" },
            [
              _c("p", { staticClass: "font-semibold mb-0" }, [
                _vm._v(_vm._s(_vm.currentUser.alias))
              ]),
              _c(
                "vx-tooltip",
                {
                  staticStyle: { display: "inline-block" },
                  attrs: {
                    text: "Click para cambiar de empresa",
                    position: "left"
                  }
                },
                [
                  _c(
                    "small",
                    {
                      staticClass: "empresa",
                      on: {
                        click: function($event) {
                          return _vm.selectCompany()
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "nombreEmpresa",
                          staticStyle: { "margin-top": "-2px" }
                        },
                        [_vm._v(_vm._s(_vm.company.fantasia))]
                      ),
                      _c("div", { staticStyle: { "margin-top": "-2px" } }, [
                        _vm._v(_vm._s(_vm.formatear(_vm.company.iut)))
                      ])
                    ]
                  )
                ]
              ),
              _vm.isProviderPortal
                ? _c(
                    "vx-tooltip",
                    {
                      staticClass: "ml-5",
                      staticStyle: { display: "inline-block" },
                      attrs: {
                        text: "Click para cambiar cliente",
                        position: "bottom"
                      }
                    },
                    [
                      _c(
                        "small",
                        {
                          staticClass: "empresa",
                          on: {
                            click: function($event) {
                              return _vm.selectCompany()
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "nombreEmpresa",
                              staticStyle: { "margin-top": "-2px" }
                            },
                            [_vm._v(_vm._s(_vm.fantasia))]
                          ),
                          _c("div", { staticStyle: { "margin-top": "-2px" } }, [
                            _vm._v(_vm._s(_vm.formatear(_vm.company.iut)))
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "vs-dropdown",
        {
          staticClass: "cursor-pointer",
          attrs: {
            "vs-custom-content": "",
            "vs-trigger-click": "",
            "data-cy": "user-profile"
          }
        },
        [
          _c("div", { staticClass: "con-img ml-3" }, [
            _c("img", {
              key: "onlineImg",
              staticClass: "rounded-full shadow-md cursor-pointer block",
              attrs: {
                src: _vm.avatar,
                alt: "user-img",
                width: "40",
                height: "40"
              }
            })
          ]),
          _c(
            "vs-dropdown-menu",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED075",
                  expression: "'ED075'"
                }
              ],
              staticClass: "vx-navbar-dropdown"
            },
            [
              _c(
                "ul",
                { staticStyle: { "min-width": "200px" } },
                [
                  _c(
                    "li",
                    {
                      staticClass:
                        "flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white",
                      attrs: { "data-cy": "profile" },
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/usuario/perfil")
                        }
                      }
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "UserIcon", svgClasses: "w-4 h-4" }
                      }),
                      _c("span", { staticClass: "ml-2" }, [_vm._v("Perfil")])
                    ],
                    1
                  ),
                  _vm.product !== "aprobacionesApp"
                    ? _c(
                        "CheckPermission",
                        { attrs: { permission: "ED033" } },
                        [
                          _c(
                            "li",
                            {
                              staticClass:
                                "flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white",
                              attrs: { "data-cy": "user-admin" },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push(
                                    "/administracion/usuarios"
                                  )
                                }
                              }
                            },
                            [
                              _c("feather-icon", {
                                attrs: {
                                  icon: "UsersIcon",
                                  svgClasses: "w-4 h-4"
                                }
                              }),
                              _c("span", { staticClass: "ml-2" }, [
                                _vm._v("Admin. Usuarios")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.product !== "aprobacionesApp"
                    ? _c(
                        "CheckPermission",
                        { attrs: { permission: "FEB99" } },
                        [
                          _c(
                            "li",
                            {
                              staticClass:
                                "flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white",
                              attrs: { "data-cy": "param-admin" },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push(
                                    "/" +
                                      _vm.app +
                                      "/configuraciones/parametros"
                                  )
                                }
                              }
                            },
                            [
                              _c("feather-icon", {
                                attrs: {
                                  icon: "EditIcon",
                                  svgClasses: "w-4 h-4"
                                }
                              }),
                              _c("span", { staticClass: "ml-2" }, [
                                _vm._v("Admin. Parametros")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _c("vs-divider", { staticClass: "m-1" }),
                  _c(
                    "li",
                    {
                      staticClass:
                        "flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white",
                      attrs: { "data-cy": "logout" },
                      on: { click: _vm.logout }
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "LogOutIcon", svgClasses: "w-4 h-4" }
                      }),
                      _c("span", { staticClass: "ml-2" }, [_vm._v("Salir")])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }